import {
  IAccount,
  IAccountProfile,
  IDeleteAccount,
  IEditAccount,
  IEditAccountQuery,
  IEditTechnician,
  IGetAccountParams,
  IGetAllParams,
  IGetAllResponse,
  IResponseTransferDistributor,
  ITransferDistributor,
  IUpdatePassword,
} from '~/utils/interface/account';
import axiosClient from './axiosClient';

const accountApi = {
  getInfo() {
    return axiosClient.get<IAccountProfile>('/api/account/info');
  },
  getTransferDistributorInfo(params: ITransferDistributor) {
    return axiosClient.get<IResponseTransferDistributor>('/api/account/transfer-distributor-info', { params });
  },
  getByRole(params: IGetAllParams) {
    return axiosClient.get<IAccount[]>(`/api/account/get-by-role`, { params });
  },
  getByRoleList(role: string, data: IGetAllParams) {
    return axiosClient.post<IGetAllResponse>(`/api/account/find-by-role`, data, { params: { role } });
  },
  findByRoleList(params: IGetAccountParams, data: IGetAllParams) {
    return axiosClient.post<IGetAllResponse>(`/api/account/find-by-role`, data, { params: params });
  },
  transferDistributor(data: ITransferDistributor) {
    return axiosClient.post<any>('/api/account/transfer-distributor', data);
  },
  createByRole(params: IEditAccountQuery, data: IEditAccount) {
    return axiosClient.post<IAccount>(`/api/account/create-by-role`, data, { params });
  },
  assignToTechnician(data: IEditTechnician) {
    const { username, technician } = data;
    return axiosClient.put<IAccount>(`/api/account/update-technician?username=${username}&technician=${technician}`);
  },
  updateByRole(data: IEditAccount) {
    return axiosClient.put<IAccount>(`/api/account/update`, data);
  },
  updatePassword(params: IEditAccountQuery, data: IUpdatePassword) {
    return axiosClient.post<IAccount>(`/api/account/update-password`, data, { params });
  },
  deleteByRole(data: IDeleteAccount) {
    return axiosClient.delete<IAccount>(`/api/account/delete-by-role `, { data });
  },
};
export default accountApi;
